import { render, staticRenderFns } from "./ReservationDetail.vue?vue&type=template&id=04dba9d6&scoped=true&"
import script from "./ReservationDetail.vue?vue&type=script&lang=ts&"
export * from "./ReservationDetail.vue?vue&type=script&lang=ts&"
import style0 from "./ReservationDetail.vue?vue&type=style&index=0&id=04dba9d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04dba9d6",
  null
  
)

export default component.exports